export default "__VITE_ASSET__DWNSiyBx__"